import { render, staticRenderFns } from "./tender-all-detail.vue?vue&type=template&id=4657e9bc&scoped=true"
import script from "./tender-all-detail.vue?vue&type=script&lang=js"
export * from "./tender-all-detail.vue?vue&type=script&lang=js"
import style0 from "./tender-all-detail.vue?vue&type=style&index=0&id=4657e9bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4657e9bc",
  null
  
)

export default component.exports